import React from "react";
import { Badge } from "react-bootstrap";

const OrderProductVerifStatus = ({ order, order_product }) => {
  if (
    order_product.checking_status === "done" ||
    !order_product.checking_status
  ) {
    return null;
  }

  if (!order.intern_packer) {
    return null;
  }

  return <Badge variant="danger">verif-absent</Badge>;
};

export default OrderProductVerifStatus
